export const INITIAL_LOADING_TEXT = 'Loading course data...'
export const SELA_ROUTE = 'sel-for-adults'
export const FT_ROUTE = 'sel-for-adults-field-test'
